import { PropsWithChildren, useEffect } from 'react'
import { generatePath, useNavigate, useParams } from 'react-router'
import { useDispatch } from 'react-redux'

import { app } from '../configuration'
import { routesPath } from '../router'
import { actions } from '../redux'

type LocaleGuardProps = PropsWithChildren

const LocaleGuard = ({ children }: LocaleGuardProps) => {
  const dispatch = useDispatch()
  const params = useParams<{ locale: string }>()
  const navigate = useNavigate()
  const locale = params.locale || ''
  const navigatorLanguage = navigator.language.split('-')?.[0]

  useEffect(() => {
    if (!app.AVAILABLE_LOCALES.includes(locale)) {
      const fallbackLocale = app.AVAILABLE_LOCALES.includes(navigatorLanguage)
        ? navigatorLanguage
        : app.DEFAULT_LOCALE

      dispatch(actions.app.setCurrentLocale(fallbackLocale))
      navigate(generatePath(routesPath.home, { locale: fallbackLocale }), { replace: true })
    } else {
      dispatch(actions.app.setCurrentLocale(locale))
    }
  }, [locale, navigate, dispatch, navigatorLanguage])

  if (!app.AVAILABLE_LOCALES.includes(locale)) {
    return null
  }

  return children
}

export default LocaleGuard
